import {
  LandingPageCustom,
  landingPageCustomSchema,
  type LandingPageCustomProps,
} from '../../components/LandingPageCustom';
import { serverLogger } from '../../utils/loggers/server';
import { getCachedEntryByUrl } from '../../utils/requests/contentstack/cachedRequests';

export const getStaticProps = async () => {
  try {
    const entry = await getCachedEntryByUrl({
      contentType: 'landing_page_custom',
      url: '/all/affiliates',
      schema: landingPageCustomSchema,
      logger: serverLogger,
    });

    return {
      props: entry.data,
      revalidate: 300,
    };
  } catch (error) {
    serverLogger({
      level: 'error',
      team: 'client-onboarding',
      message: 'Failed to fetch required page data - /all/affiliates',
      context: {
        error,
        page: '/all/affiliates',
        severity: 'critical',
      },
    });

    throw new Error('Required data not provided to render /all/affiliates');
  }
};

const AffiliatesPage = ({ seoData, modules }: LandingPageCustomProps) => {
  return <LandingPageCustom seoData={seoData} modules={modules} />;
};

export default AffiliatesPage;
